import React, { useContext, useEffect, useMemo, useState } from 'react';
import Slick from "react-slick";
import { Box, Skeleton } from "@mui/material";
import { ErrorContext } from "../../../components/GympinPagesProvider";
import { getListByViewType, getQueryResults } from "./_ep_queries";

const normalizeButtonListSlickSettings = (parsed, itemCount) => {
    const settings = {
        rtl: true,
        swipeToSlide: true,
        arrows: false,
        dots: false,
        ...parsed,
        infinite: false,
        // یک‌به‌یک جلو می‌رود تا در آخر لیست (وقتی تعداد آیتم مضرب slidesToShow نیست) فضای خالی RTL ایجاد نشود.
        slidesToScroll: 1
    };

    if (itemCount > 0 && settings.slidesToShow > itemCount) {
        settings.slidesToShow = itemCount;
    }

    if (Array.isArray(settings.responsive)) {
        settings.responsive = settings.responsive.map((breakpoint) => {
            const bpSettings = { ...(breakpoint.settings || {}), slidesToScroll: 1, infinite: false };
            if (itemCount > 0 && bpSettings.slidesToShow > itemCount) {
                bpSettings.slidesToShow = itemCount;
            }
            return { ...breakpoint, settings: bpSettings };
        });
    }

    return settings;
};

const _ep_CAROUSEL_BUTTON_LIST = ({ carousel }) => {
    const error = useContext(ErrorContext);
    const isStatic = !carousel?.Items?.[0]?.Type?.startsWith("QUERY");
    const [items, setItems] = useState(() => isStatic ? carousel?.Items : null);
    const itemType = carousel?.Items?.[0]?.ViewType;
    const carouselId = carousel?.Id || carousel?.Description;

    useEffect(() => {
        if (!carousel) return;
        if (isStatic && carousel?.Items) {
            setItems(carousel.Items);
            return;
        }

        let isMounted = true;
        getQueryResults(carousel, error)
            .then(result => {
                if (isMounted) setItems(result);
            })
            .catch(e => {
                console.error("Button list query error:", e);
            });

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carouselId, isStatic]);

    const displayItems = useMemo(() => {
        if (!items || !items.length) return [];
        if (items.length >= 4) return items;
        let list = items;
        while (list.length < 4) {
            list = [...list, ...items];
        }
        return list.slice(0, 4);
    }, [items]);

    const slickSettings = useMemo(() => {
        let parsed = {};
        try {
            if (carousel?.Data) {
                parsed = typeof carousel.Data === "object" ? carousel.Data : JSON.parse(carousel.Data);
            }
        } catch {
            parsed = {};
        }

        return normalizeButtonListSlickSettings(parsed, displayItems.length);
    }, [carousel?.Data, displayItems.length]);

    if (!items) {
        return (
            <Box sx={{ display: "flex", gap: 2, px: { xs: 2, sm: 2.5 }, my: 2, overflow: "hidden" }}>
                {[1, 2, 3, 4, 5].map((i) => (
                    <Box key={i} sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                        <Skeleton
                            variant="rounded"
                            width={76}
                            height={76}
                            sx={{ borderRadius: "22px" }}
                            animation="wave"
                        />
                        <Skeleton variant="text" width={56} height={14} animation="wave" />
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box
            className="home-category-carousel"
            sx={{ py: 1, px: { xs: 1, sm: 1.5 }, overflow: "hidden" }}
            dir="rtl"
        >
            <Slick key={`${carouselId}-${displayItems.length}`} {...slickSettings}>
                {displayItems.map((item, index) => getListByViewType(itemType, item, index))}
            </Slick>
        </Box>
    );
};

export default React.memo(_ep_CAROUSEL_BUTTON_LIST);

